export default "__VITE_ASSET__Cf67Fjs9__"